/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {syncEntitiesFranklin} from '../api'

export const useMutationSyncEntitiesFranklin = createReactQueryMutationHook('syncEntitiesFranklin', syncEntitiesFranklin)
